import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const UnarchiveSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default UnarchiveSVG;
